


















































import Vue from 'vue';
import {
  Component, Prop, Watch,
} from 'vue-property-decorator';
import {
  IQualifier, IbLoginQualifier, EStatementQualifier, AchQualifier,
  PosQualifier, CreditCardQualifier, CreditOrDebitCardQualifier, MinimumBalanceQualifier, LinkedAccountQualifier,
  LoanQualifier,
} from '@/api/product/levelrewards/qualifiers';
import { ProductTypeMap } from '@/api/producttypes';
import { AccountProductTypeMap } from '@/api/accountproducttypes';
import { ProductMapping } from '@/api/productmapping';
import { ValidationTool } from '@/util';
import AchQualifierEditor from './AchQualifierEditor.vue';
import MinimumBalanceQualifierEditor from './MinimumBalanceQualifierEditor.vue';
import PosQualifierEditor from './PosQualifierEditor.vue';
import CreditOrDebitCardQualifierEditor from './CreditOrDebitCardQualifierEditor.vue';
import CreditCardQualifierEditor from './CreditCardQualifierEditor.vue';
import LoanQualifierEditor from './LoanQualifierEditor.vue';

@Component({
  components: {
    AchQualifierEditor,
    MinimumBalanceQualifierEditor,
    PosQualifierEditor,
    CreditOrDebitCardQualifierEditor,
    CreditCardQualifierEditor,
    LoanQualifierEditor,
  },
})
export default class EditQualificationDialog extends Vue {
  @Prop()
  value!:IQualifier;

  @Prop({ default: false })
  smallIcon!:boolean;

  @Prop()
  productType!:string;

  @Prop({ default: false })
  isEditable!: boolean;

  @Prop()
  productTypes!: ProductTypeMap;

  @Prop()
  productMappings!: ProductMapping[];

  @Prop()
  accountProductTypes!: AccountProductTypeMap;

  workingQualifier:IQualifier | null = null;

  dialog:boolean = false;

  isFormValid:boolean = true;

  selectedQualType: string | null = null;

  selectableQualTypes: any[] = [];

  // Make visible to the template
  AchQualifier: any = AchQualifier;

  MinimumBalanceQualifier: any = MinimumBalanceQualifier;

  PosQualifier: any = PosQualifier;

  CreditOrDebitCardQualifier: any = CreditOrDebitCardQualifier;

  CreditCardQualifier: any = CreditCardQualifier;

  LoanQualifier: any = LoanQualifier;

  requiredRule:Array<any> = [(value: any) => {
    if (value === null || value === undefined || (Array.isArray(value) && value.length === 0)) {
      return 'Required';
    }
    return true;
  }];

  requiredAndPositiveRule:Array<any> = [ValidationTool.requiredAndPositiveRuleFunction];

  mounted() {
    this.initialize();
  }

  /* eslint-disable no-underscore-dangle */
  @Watch('dialog')
  initialize() {
    if (this.dialog) {
      if (this.value) {
        this.workingQualifier = this.value.clone();
        this.selectedQualType = this.value._class;
      } else {
        this.workingQualifier = null;
        this.selectedQualType = null;
      }
      this.buildSelectableQualTypes();
    }
  }

  buildSelectableQualTypes() {
    this.selectableQualTypes = [
      {
        text: AchQualifier.NAME,
        value: AchQualifier.CLASS,
      },
      {
        text: EStatementQualifier.NAME,
        value: EStatementQualifier.CLASS,
      },
      {
        text: MinimumBalanceQualifier.NAME,
        value: MinimumBalanceQualifier.CLASS,
      },
      {
        text: IbLoginQualifier.NAME,
        value: IbLoginQualifier.CLASS,
      },
      {
        text: LoanQualifier.NAME,
        value: LoanQualifier.CLASS,
      }];

    if (!this.productType.endsWith('_EDGE')) {
      this.selectableQualTypes.push({
        text: PosQualifier.NAME,
        value: PosQualifier.CLASS,
      });
    }

    this.selectableQualTypes.push({
      text: CreditCardQualifier.NAME,
      value: CreditCardQualifier.CLASS,
    });

    if (!this.productType.endsWith('_EDGE')) {
      this.selectableQualTypes.push({
        text: CreditOrDebitCardQualifier.NAME,
        value: CreditOrDebitCardQualifier.CLASS,
      });
    }
  }

  @Watch('selectedQualType')
  onNewSelectedQualType() {
    if (this.selectedQualType && (this.workingQualifier === null || this.workingQualifier._class !== this.selectedQualType)) {
      switch (this.selectedQualType) {
        case AchQualifier.CLASS: {
          this.workingQualifier = new AchQualifier();
          break;
        }

        case CreditCardQualifier.CLASS: {
          this.workingQualifier = new CreditCardQualifier();
          break;
        }

        case CreditOrDebitCardQualifier.CLASS: {
          this.workingQualifier = new CreditOrDebitCardQualifier();
          break;
        }

        case EStatementQualifier.CLASS: {
          this.workingQualifier = new EStatementQualifier();
          break;
        }

        case IbLoginQualifier.CLASS: {
          this.workingQualifier = new IbLoginQualifier();
          break;
        }

        case LinkedAccountQualifier.CLASS: {
          this.workingQualifier = new LinkedAccountQualifier();
          break;
        }

        case MinimumBalanceQualifier.CLASS: {
          this.workingQualifier = new MinimumBalanceQualifier();
          break;
        }

        case PosQualifier.CLASS: {
          this.workingQualifier = new PosQualifier();
          break;
        }

        case LoanQualifier.CLASS: {
          this.workingQualifier = new LoanQualifier();
          break;
        }

        default:
          throw new Error(`Unknown qualifier type: ${this.selectedQualType}`);
      }
    }
  }

  cancel() {
    const form: any = this.$refs.form;
    form.reset();
    this.dialog = false;
  }

  save() {
    this.$emit('input', this.workingQualifier);
    this.dialog = false;
  }

  /* eslint-enable no-underscore-dangle */
}
